import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { BlockCompanyDetailsComponent } from '../block-company-details/block-company-details.component';

@Component({
    selector: 'app-modal-company-information',
    templateUrl: './modal-company-information.component.html',
    styleUrls: ['./modal-company-information.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [BlockCompanyDetailsComponent]
})
export class ModalCompanyInformationComponent implements OnInit {
    
    @Input() companyData;
    @Input() fromLayout = false;

    constructor(
        private modalService: BsModalService,
        public bsModalRef: BsModalRef,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) { }

    ngOnInit(): void {
    }
}
